import * as React from 'react';
import { cn } from '~/lib/utils';
import { useUserSession } from '~/modules/user/components/impersonate-user/user-session-context';
export interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {}
const Input = React.forwardRef<HTMLInputElement, InputProps>(({
  className,
  type,
  ...props
}, ref) => {
  const {
    isClientInterfaceVariant,
    isAdminInterfaceVariant
  } = useUserSession();
  return <input type={type} className={cn({
    'h-9 rounded-[110px] border px-3 shadow-[0px_2px_4px_0px_#1431761A] placeholder:text-[#7c7c7c]': isClientInterfaceVariant,
    'flex h-10 w-full rounded-lg border border-input bg-background px-3 py-2 text-base font-medium ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:font-normal placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50': isAdminInterfaceVariant
  }, className)} ref={ref} {...props} />;
});
Input.displayName = 'Input';
export { Input };